import './ring-loader.scss';

import React from 'react';

const RingLoader = () => {
  return (
    <div className="ring__loader">
      <div />
    </div>
  );
};

export { RingLoader };
